import { ResearcherAssetStatus } from '../../shared/configurations/researcher-asset-status.constant';

export const menuActions = {
    export: { name: 'research.output.list.action.export.asset' },
    message: { name: 'research.output.list.action.message.list' },
    view: { name: 'research.output.list.menu.view' },
    files: { name: 'research.output.list.action.add.files.links' },
    edit: { name: 'research.output.list.menu.edit' },
    delete: { name: 'research.output.list.menu.delete' },
    hide: { name: 'research.output.list.action.hide.asset' },
    unhide: {
        name: 'research.output.list.action.unhide.asset',
        divider: 'after',
    },
    viewChanges: { name: 'research.output.list.menu.viewChanges' },
};

/**
 * The key for this items should take from 'ResearcherAssetStatus' enum
 * and the values from menuActions key, otherwise it faile
 */
export const profileMenuItems = {
    [ResearcherAssetStatus.DRAFT]: ['edit', 'delete'],
    draftManuForNonAuthorized: [],
    [ResearcherAssetStatus.SUBMITTED]: ['export', 'message', 'view', 'files'],
    [ResearcherAssetStatus.RESUBMITTED]: ['export', 'message', 'view', 'files'],
    [ResearcherAssetStatus.UNDER_REVIEW]: [
        'export',
        'message',
        'view',
        'files',
    ],
    [ResearcherAssetStatus.PENDING_APPROVAL]: [
        'export',
        'message',
        'view',
        'files',
    ],
    [ResearcherAssetStatus.RETURNED]: ['edit', 'delete', 'export', 'message'],
    returnedMenuForNonAuthorized: ['export', 'message'],
    [ResearcherAssetStatus.APPROVED]: [
        'view',
        'edit',
        'viewChanges',
        'hide',
        'files',
        'export',
        'message',
    ],
    [ResearcherAssetStatus.IMPORTED]: [
        'view',
        'edit',
        'viewChanges',
        'hide',
        'files',
        'export',
        'message',
    ],
    hiddenApprovedMenu: [
        'unhide',
        'view',
        'edit',
        'viewChanges',
        'files',
        'export',
        'message',
    ],
};

export const draftActions = [
    {
        name: 'research.output.list.menu.edit',
        icon: 'pencil',
        tooltip: 'research.output.list.menu.edit.draft.tooltip',
    },
];
export const draftActionsForNonAuthorized = [];

export const additionalMenuItems = {
    apcAction: {
        name: 'research.output.list.action.apc.request',
        disabled: false,
    },
};
